/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("DOMContentLoaded", function () {

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector(
                "product-recommendations"
              );

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (
                !this.querySelector("slideshow-component") &&
                this.classList.contains("complementary-products")
              ) {
                this.remove();
              }

              if (html.querySelector(".grid__item")) {
                this.classList.add("product-recommendations--loaded");
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
    }

    customElements.define("product-recommendations", ProductRecommendations);

    if (!customElements.get("custom-select")) {
      customElements.define(
        "custom-select",
        class CustomSelect extends HTMLElement {
          constructor() {
            super();
            this.selectBtn = this.querySelector(".select-button");
            this.selectedValue = this.querySelector(".selected-value");
            this.optionsList = this.querySelectorAll(".select-dropdown li");
            this.inputsList = this.querySelectorAll(
              ".select-dropdown input[type=radio]"
            );

            this.selectBtn.addEventListener(
              "click",
              this.toggleSelect.bind(this)
            );
            // this.selectBtn.addEventListener("blur", this.closeOnBlur.bind(this));
            document.addEventListener(
              "click",
              this.closeOnOutsideClick.bind(this)
            );

            this.optionsList.forEach((option) => {
              option.addEventListener(
                "keyup",
                this.handleOptionSelect.bind(this)
              );
              option.addEventListener(
                "click",
                this.handleOptionSelect.bind(this)
              );
            });

            this.inputsList.forEach((input) => {
              input.addEventListener(
                "change",
                this.handleOptionSelect.bind(this)
              );
            });
          }

          closeOnOutsideClick(event) {
            // Check if the click target is not within the custom select container
            if (
              !this.contains(event.target) &&
              this.classList.contains("active")
            ) {
              this.classList.remove("active");
              this.selectBtn.setAttribute("aria-expanded", "false");
            }
          }
          closeOnBlur(event) {
            // Check if the blur event occurred on the select button
            if (event.target === this.selectBtn) {
              if (this.selectBtn.getAttribute("aria-expanded") === "true") {
                this.classList.remove("active");
                this.selectBtn.setAttribute("aria-expanded", "false");
              }
            }
          }

          toggleSelect(e) {
            e.preventDefault();
            this.classList.toggle("active");
            this.selectBtn.setAttribute(
              "aria-expanded",
              this.selectBtn.getAttribute("aria-expanded") === "true"
                ? "false"
                : "true"
            );
          }

          connectedCallback() {
            // this is called when the element is first connected to the DOM
            if (this.inputsList.length > 0) {
              this.inputsList[0].checked = true;
              this.inputsList[0].dispatchEvent(new Event("change"));
            }
          }

          handleOptionSelect(e) {
            const li = e.target.closest("li");
            if (
              li &&
              ((e.type === "click" && e.clientX !== 0 && e.clientY !== 0) ||
                e.key === "Enter" ||
                e.type === "change")
            ) {
              const label = li.querySelector("label");
              const input = li.querySelector("input");
              if (label && input.checked) {
                this.selectedValue.innerHTML = label.innerHTML;
                this.classList.remove("active");
              } else {
                this.selectedValue.innerHTML = "<p>Select</p>";
              }
            }
          }
        }
      );
    }
  });

  function handleSubscriptionGroupChange(event) {
    let price;
    const ref = event.target;
    if (ref.checked) {
      price = ref
        .closest(".FH_product__subs__group")
        ?.querySelector("[data-product-price]")?.dataset.price;

      const itemsToReplacePrice = document.querySelectorAll(
        "[data-product-price]:not(.FH_product__subs__group [data-product-price]), [data-button-price]:not(.FH_product__subs__group [data-product-price])"
      );

      if (itemsToReplacePrice.length === 0) {
        return; // Guard clause to handle the condition early
      }

      itemsToReplacePrice.forEach((item) => {
        item.innerHTML = price;
      });
    }

    intializeSwappableProduct()
  }

  function subscriptionBoxDisplay(variant_id) {
    const subscriptionBox = document.querySelector(
      "[data-subscription-box]"
    );

    if (
      Shopify.variantPlans &&
      Shopify.variantPlans[variant_id]?.selling_plans.length === 0
    ) {
      subscriptionBox?.classList.add("hide");
      document
        .querySelector(".one_time_purchase_box")
        ?.querySelector("label")
        .click();
    } else {
      subscriptionBox?.querySelector("label").click();
      subscriptionBox?.classList.remove("hide");
    }

    const toggles = document.querySelectorAll("[data-toggles-group]");
    toggles.forEach((toggle) => {
      toggle.addEventListener("change", handleSubscriptionGroupChange);
    });
  }
  subscriptionBoxDisplay(Shopify.subscription?.selectedVariantId);

  function intializeSwappableProduct() {
    // const is_subscription = document.querySelector("input[name='mode']:checked")?.value === "subscription";
    // const product_swap_note_input = document.getElementById(
    //   "product_swap_note"
    // );
    // product_swap_note_input.value = is_subscription ? "Subscribed" : "";
  }
  intializeSwappableProduct();

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    let variant = event.detail.variant;
    subscriptionBoxDisplay(variant.id);
    intializeSwappableProduct();
    // var container = event.target;
    if (variant && Shopify.variantPlans[variant.id]) {
      let customSelect = `
          <custom-select class="custom-select ${
            Shopify.variantPlans[variant.id].selling_plans.length === 0
              ? "hide"
              : ""
          }">
            <button 
              class="select-button" 
              role="combobox" 
              aria-labelledby="select button" 
              aria-haspopup="listbox" 
              aria-expanded="false" 
              aria-controls="select-dropdown" 
              type="button"
            >
              <span class="selected-value plan_text_wrap">
                ${theme.strings.subscription}
              </span>
              <span class="select-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4 6L8 10L12 6" stroke="#333333" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </button>

            <ul class="select-dropdown" role="listbox" id="select-dropdown">
              ${Shopify.variantPlans[variant.id].selling_plans
                .map((plan, index) => {
                  const subtitle = (plan.description ?? "").split("-")[0];
                  return `<li role="option">
                  <input 
                    type="radio" 
                    id="${index}-${plan.id}"
                    name="selling_plan" 
                    data-custom-select-option
                    value="${plan.id}" 
                  >
                  <label for="${index}-${plan.id}" class="plan_text_wrap FH_product__subs__option">
                    <span>${plan.name}</span>
                    <!-- <span>${subtitle}</span> -->
                  </label>
                </li>`;
                })
                .join("")}
            </ul>
          </custom-select>
  `;
      const customSelectWrapper = document.querySelector(
        ".custom-select-wrapper"
      );
      if (customSelectWrapper) {
        customSelectWrapper.innerHTML = customSelect;
      }

      // ... update some element on the page
    }
  });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // // Debounced scroll listeners.  Up and down only fire on direction changes
  // // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
